import React from 'react';
import { Alert, AlertTitle  } from '@material-ui/lab';

const ErrorValidationAlert = ({ errors }) => {
    return (
        <>
            {Object.keys(errors).length > 0 &&
                <div className="row mb-1">
                    <div className="col-md-12 col-sm-12 col-xs-12">
                        <Alert severity="error">
                            <AlertTitle className="text-left">Errors</AlertTitle>
                            <ul>
                                {Object.keys(errors).map((key, index) => 
                                    <li className="text-left" key={index}>{errors[key][0]}</li>
                                )}
                            </ul>
                        </Alert>
                    </div>
                </div>
            }
        </>
    );
};

export default ErrorValidationAlert;
